import { isEducation } from './permissions'
import store from '../../store'

export const KEYS = {
    METADATA: 'metadata',
}

function checkAccess(type) {
    try {
        let storage = window[type]
        let x = '__storage_test__'
        storage.setItem(x, x)
        storage.removeItem(x)
        return true
    } catch (e) {
        return false
    }
}

const _global = {}

function getValue(key, castTo = null) {
    let result
    if (checkAccess('localStorage')) result = window.localStorage.getItem(key)
    else if (checkAccess('sessionStorage')) result = window.sessionStorage.getItem(key)
    else {
        result = _global[key]
    }

    return castTo && castTo === Object ? JSON.parse(result) : result
}

function setValue(key, value) {
    let _value = value
    if (_value instanceof Object) _value = JSON.stringify(value)
    window.localStorage.setItem(key, _value)
}

export const updateLocalStorageMetadata = () => {
    const { user_details, payments } = store.getState()

    const result = {
        userId: null,
        countryCode: null,
        isEducation: null,
        interestTags: [],
    }

    if (user_details) {
        result.userId = user_details.id
        if (!!user_details.interestTags?.length) {
            result.interestTags = user_details.interestTags.map(tag => tag.name)
        }
        result.isEducation = isEducation()
    }
    if (payments) {
        if (payments.countryCode) result.countryCode = payments.countryCode
    }

    setValue(KEYS.METADATA, JSON.stringify(result))
}

export default {
    checkAccess,
    getValue,
    setValue,
}
